import api from "axios";

export function getBalance() {
  return api
    .get("/purchasers/dashboard/balance")
    .then((response) => response.data.payload);
}